import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { fad } from '@awesome.me/kit-b4fd369ea4/icons';
import { DimRearrangeDialog } from './DimRearrangeDialog';

export const DimRearrangeButton = ({ setDims, codeToDim, activeDims, numFrozenDims }) => {
  const { openDialog } = useDialog();

  const openDimRearrangeDialog = () => {
    openDialog(DimRearrangeDialog, { codeToDim, activeDims, numFrozenDims }).then((dimCodes) => {
      if (dimCodes) setDims(dimCodes);
    });
  };

  return <TitleButton icon={fad.faLayerGroup} toolTip="Rearrange Dimensions" onClick={openDimRearrangeDialog} />;
};
